import { configs } from '@constants/configs/configs';
import { ENABLED_SSAP_DATA_INCONSISTENCY_RULE_IDS } from './ssapDataInconsistencyConfig';
import { SSAP_DATA_INCONSISTENCY_RULES_BY_ID } from './ssapDataInconsistencyRules';
import { resolveTaxHouseholdReadOnly } from './resolveTaxHouseholdReadOnly';

const hasAnalyzableTaxHousehold = data => resolveTaxHouseholdReadOnly(data) != null;

/**
 * Runs enabled inconsistency rules against raw SSAP application data.
 * @param {object} data - SSAP application JSON (as stored in state.ssap.data)
 * @returns {{ issues: object[], issueCount: number }}
 */
export const analyzeSsapDataInconsistencies = data => {
    if (!hasAnalyzableTaxHousehold(data)) {
        return {
            issues: [],
            issueCount: 0,
        };
    }

    const issues = [];

    ENABLED_SSAP_DATA_INCONSISTENCY_RULE_IDS.forEach(ruleId => {
        const rule = SSAP_DATA_INCONSISTENCY_RULES_BY_ID[ruleId];

        if (!rule) {
            if (configs.ENV.DEVELOPMENT) {
                console.warn(
                    `[SSAP data inconsistency] Enabled rule "${ruleId}" has no implementation in SSAP_DATA_INCONSISTENCY_RULES_BY_ID.`,
                );
            }
            return;
        }

        rule.run(data, issue => {
            issues.push(issue);
        });
    });

    return {
        issues,
        issueCount: issues.length,
    };
};
